import { useCallback, useMemo } from "react";
import PublicationRecord from "models/view-models/publication-record";

export interface PublicationSortItem {
    id: number;
    publication: PublicationRecord;
    displaySequence: number;
}

interface UsePublicationSortItems {
    publicationsFromSortItems: (
        sortItems: PublicationSortItem[]
    ) => PublicationRecord[];
    publicationSortItems: PublicationSortItem[];
}

const publicationToSortItem = (
    publication: PublicationRecord,
    index: number
): PublicationSortItem => ({
    id: publication.id!,
    displaySequence: index * 100,
    publication: publication,
});

export const usePublicationSortItems = (
    initialPublications: PublicationRecord[]
): UsePublicationSortItems => {
    const publicationSortItems = useMemo(
        () => initialPublications.map(publicationToSortItem),
        [initialPublications]
    );

    const publicationsFromSortItems = useCallback(
        (sortItems: PublicationSortItem[]): PublicationRecord[] =>
            sortItems
                .map((item): PublicationRecord | undefined =>
                    initialPublications.find((p) => p.id === item.id)
                )
                .filter((p): p is PublicationRecord => p != null),
        [initialPublications]
    );

    return {
        publicationsFromSortItems: publicationsFromSortItems,
        publicationSortItems: publicationSortItems,
    };
};
